'use strict';

/* globals document, $ */

$(document).ready(function () {

});

